module.exports = __webpack_public_path__ + "static/map_puxi_new-486b73a2b3fae60a677d44c1f3b2f299.jpg";